import { IconProps } from "@/src/sb/business-layer/types"

const Ribbon = (props: IconProps) => (
  <svg
    width={props.width ?? props.size ?? 16}
    height={props.height ?? props.size ?? 16}
    viewBox="0 0 20 20"
    fill="none"
  >
    <g clipPath="url(#clip0_15999_53430)">
      <path
        d="M14.1665 2.5H5.83317C4.9165 2.5 4.1665 3.25 4.1665 4.16667V17.5L9.99984 15L15.8332 17.5V4.16667C15.8332 3.25 15.0832 2.5 14.1665 2.5ZM14.1665 15L9.99984 13.1833L5.83317 15V4.16667H14.1665V15Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_15999_53430">
        <rect width="20" height="20" fill="currentColor" />
      </clipPath>
    </defs>
  </svg>
)

export default Ribbon
